import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import type {DismissibleToastProps} from './dismissible-toast.types';
import {DEFAULT_DURATION} from './dismissible-toast.types';
import Toast from '@Components/toast';
import {useIsMounted} from '@Hooks/useIsMounted';
import styles from '@Components/loading-toast/loading-toast.module.scss';

export function DismissibleToast({...props}: DismissibleToastProps): ReactElement<any> {
  const hasMounted = useIsMounted();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, props.duration ?? DEFAULT_DURATION);
  }, []);

  const getWrapperClasses = (): string => {
    return `radius-8 ${styles.wrapper}
     ${show ? styles.in : styles.out} 
     ${hasMounted.current ? styles.doAnimate : ''} `;
  };

  return (
    <div className={getWrapperClasses()}>
      <Toast
        {...props}
        className={`spacing-p-r-3 ${props.className}`}
        onClose={() => {
          setShow(false);
        }}
      />
    </div>
  );
}
